import {environment} from "../../../environments/environment";

export class Link {
  href: string;

  constructor(data: any) {
    this.href = data.href;
  }

  /**
   * Extracts and returns the relative route from a HAL-compliant href by removing the API base URL.
   *
   * @returns The relative route as a string, obtained by removing the API base URL from the href. If the input URL does not start with the API base URL, the input URL is returned unchanged.
   */
  public getRoute(): string {
    if (environment.localInstance) {
      return this.href.replace(environment.backendUrl, "");
    } else {
      return new URL(this.href).pathname.replace(environment.backendUrl, "");
    }
  }
}

export class Links {
  links: { [key: string]: Link };

  constructor(data: any) {
    this.links = {};
    if (!data) {
      return;
    }
    // prevent nested links
    if (Object.keys(data).includes("links")) {
      data = data.links;
    }
    Object.keys(data).forEach(key => {
      this.links[key] = new Link(data[key]);
    });
  }

  static fromJSON(json: any): Links {
    return new Links(json.links);
  }

  public getLink(key: string): Link | undefined {
    return this.links[key];
  }

  public hasLink(key: string): boolean {
    return key in this.links;
  }
}
